import styled from 'styled-components';
export const TabsContainer = styled.ul `
  width: 100%;
  display: flex;
  margin: 0;
  padding: 0;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: ${({ withTabPanel }) => (withTabPanel ? '0.19rem' : '0;')};
  flex-direction: ${({ alignment }) => (alignment === 'horizontal' ? 'row;' : 'column')};
`;
